/**
 * Configuração do protótipo dentro do abe-web-react.
 */

/**
 * Prefixo de todas as rotas do protótipo. Precisa casar com o `path` dos
 * `<Route>` em `RoutesPrototipo.jsx`. Deixe `''` para montar na raiz.
 */
export const ROTA_BASE = '/prototipo';

/** Monta uma rota do protótipo já com o prefixo. */
export const rota = caminho => `${ROTA_BASE}${caminho}`;
